module.exports = __webpack_public_path__ + "static/media/seat_5.2bbd648f.png";